const baseUrl = "https://0byjgmgpv1.execute-api.eu-west-1.amazonaws.com/v1/api"

export async function apiRequest<T>(
    useBaseUrl: boolean,
    endpoint: string,
    method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
    params?: Record<string, string>,
    body?: any,
    isJson = true
): Promise<T> {
    try {
        const headers: HeadersInit = {
            'Accept': 'application/json',
            'Accept-Language': localStorage.getItem('i18nextLng') || 'en'
        };
        
        if (isJson) {
            headers["Content-Type"] = "application/json";
        }
        
        return await sendRequest(useBaseUrl, endpoint, method, params, body, headers, isJson);
    } catch (error: any) {
        throw new Error(error.message || 'An error occurred');
    }
};

async function sendRequest(
    useBaseUrl: boolean, 
    endpoint: string, 
    method: string, 
    params?: Record<string, string>,
    body?: any, 
    headers?: HeadersInit,
    isJson = true
): Promise<any> {
    try {
        let url = useBaseUrl ? `${baseUrl}${endpoint}` : `${endpoint}`;
        
        if (params) {
            const queryParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
                queryParams.append(key, value);
            });
            url += `?${queryParams.toString()}`;
        }

        let payload: BodyInit | undefined;
        if (body instanceof FormData) {
            payload = body;
        } else if (isJson && body != null) {
            payload = JSON.stringify(body);
        } else {
            payload = body;
        }

        const response = await fetch(url, {
            method,
            headers,
            body: payload,
            mode: 'cors'
        });

        if (!response.ok) {
            let errorMessage = "";
            try {
                const errorData = await response.json();
                console.log('API Error Response:', errorData);
                
                if (errorData.detail) {
                    errorMessage = errorData.detail;
                } else if (errorData.error) {
                    errorMessage = errorData.error;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                } else if (typeof errorData === 'object') {
                    const fieldErrors = Object.entries(errorData)
                        .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(', ') : errors}`)
                        .join('; ');
                    errorMessage = fieldErrors || JSON.stringify(errorData);
                } else {
                    errorMessage = JSON.stringify(errorData);
                }
            } catch (e) {
                errorMessage = `HTTP error ${response.status}`;
            }
            throw new Error(errorMessage);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}